import { render, staticRenderFns } from "./useraffiliatesettlement.vue?vue&type=template&id=6578829d&scoped=true&"
import script from "./useraffiliatesettlement.vue?vue&type=script&lang=js&"
export * from "./useraffiliatesettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6578829d",
  null
  
)

export default component.exports